import { render, staticRenderFns } from "./ContentRegister.vue?vue&type=template&id=5f8b4bc2"
import script from "./ContentRegister.vue?vue&type=script&lang=js"
export * from "./ContentRegister.vue?vue&type=script&lang=js"
import style0 from "./ContentRegister.vue?vue&type=style&index=0&id=5f8b4bc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports